import { getCookie, setCookie } from '../../scripts/utils';

const feedbackJsClass = 'js-feedback';
const buttonYesJsClass = feedbackJsClass + '-button-yes';
const buttonNoJsClass = feedbackJsClass + '-button-no';
const textJsClass = feedbackJsClass + '-text';

const feedbackElement = document.querySelector('.' + feedbackJsClass) as HTMLElement;
const buttonYesElement = document.querySelector('.' + buttonYesJsClass) as HTMLElement;
const buttonNoElement = document.querySelector('.' + buttonNoJsClass) as HTMLElement;
const textElement = document.querySelector('.' + textJsClass) as HTMLElement;

const buttonClass = 'c-button';
const buttonAppearanceLightClass = buttonClass + '--appearance-light';
const buttonAppearanceDarkClass = buttonClass + '--appearance-dark';

let pageId: string;
let urlNo: string;
let urlYes: string;

if (feedbackElement && buttonYesElement && buttonNoElement) {
    // Get data attributes
    pageId = feedbackElement.dataset.pageId;
    urlNo = feedbackElement.dataset.urlNo;
    urlYes = feedbackElement.dataset.urlYes;

    if (pageId && urlNo && urlYes) {
        // Get feedback from cookie
        const feedback = getCookie('feedback-' + pageId);

        // Update button appearance
        if (feedback === 'yes') {
            changeButtonAppearance(buttonYesElement, 'dark');
        } else if (feedback === 'no') {
            changeButtonAppearance(buttonNoElement, 'dark');
            showText(true);
        }

        // Add click event listener to yes button
        buttonYesElement.addEventListener('click', () => {
            onClick('yes');
        });

        // Add click event listener to no button
        buttonNoElement.addEventListener('click', () => {
            onClick('no');
        });

    }
}

async function onClick (answer: 'yes'| 'no'): Promise<void> {
    // Get feedback from cookie
    const feedback = getCookie('feedback-' + pageId);

    // Stop if the answer is the same as the stored feedback
    if (answer === feedback) {
        return;
    }

    // Set cookie
    setCookie('feedback-' + pageId, answer, 365);

    if (answer === 'yes') {
        // Update button appearance
        changeButtonAppearance(buttonYesElement, 'dark');
        changeButtonAppearance(buttonNoElement, 'light');

        showText(false);

        // Fetch url to notifiy backend
        try {
            await fetch(urlYes);
        } catch (error) {
            console.error(error);
        }
    } else if (answer === 'no') {
        // Update button appearance
        changeButtonAppearance(buttonNoElement, 'dark');
        changeButtonAppearance(buttonYesElement, 'light');

        showText(true);

        // Fetch url to notifiy backend
        try {
            await fetch(urlNo);
        } catch (error) {
            console.error(error);
        }
    }
}

function changeButtonAppearance (buttonElement: HTMLElement, appearance: 'light' | 'dark'): void {
    if (buttonElement && appearance) {
        if (appearance === 'light') {
            // Remove the dark class from button
            buttonElement.classList.remove(buttonAppearanceDarkClass);
            // Remove the aria pressed attribute
            buttonElement.setAttribute('aria-pressed', 'false');
            // Add the light class to button
            buttonElement.classList.add(buttonAppearanceLightClass);
        } else if (appearance === 'dark') {
            // Remove the light class from button
            buttonElement.classList.remove(buttonAppearanceLightClass);
            // Add the aria pressed attribute
            buttonElement.setAttribute('aria-pressed', 'true');
            // Add the dark class to button
            buttonElement.classList.add(buttonAppearanceDarkClass);
        }
    }
}

function showText (show: boolean): void {
    if (show) {
        textElement.style.display = 'block';
    } else {
        textElement.style.display = 'none';
    }
}